import classNames from 'classnames';
import * as React from 'react';

import { ClientComment } from './ClientComment';
import { Header } from './Header';
import { Images } from './Images';
import { Info } from './Info';
import * as styles from './styles.css';
import { MapOfferCardCommentContainer } from '../../containers/MapOfferCardCommentContainer';
import { IFavoriteEntity } from '../../types/favoriteEntity';
import { EGetOffersByRealtyOfferIdStatus } from '../../types/offersByRealtyOfferId';
import { Preloader } from '../Preloader';

interface IMapOfferCardProps {
  selectedOffer: IFavoriteEntity;
  isCardOpen: boolean;
  handleCloseOfferCard: () => void;
  offersByRealtyOfferIdStatus: EGetOffersByRealtyOfferIdStatus;
  isSearcherOrSub?: boolean;
}

export const MapOfferCard = ({
  selectedOffer,
  isCardOpen,
  handleCloseOfferCard,
  offersByRealtyOfferIdStatus,
  isSearcherOrSub,
}: IMapOfferCardProps) => {
  const { clientReactions } = selectedOffer;

  const isShowClientComment = clientReactions && (clientReactions.likeDislikeReaction || clientReactions.comment);

  return (
    <div className={classNames(styles['container'], isCardOpen && styles['container_active'])}>
      <Header onClose={handleCloseOfferCard} />
      {offersByRealtyOfferIdStatus === EGetOffersByRealtyOfferIdStatus.Loading && isCardOpen && (
        <div key="preloader" className={styles['preloader']} data-testid="preloader">
          <Preloader size={32} />
        </div>
      )}
      {offersByRealtyOfferIdStatus === EGetOffersByRealtyOfferIdStatus.Succeed && (
        <div className={styles['card_container']}>
          <div className={styles['info_container']}>
            <div>
              <Images offer={selectedOffer} />
            </div>
            <div>
              <Info offer={selectedOffer} />
            </div>
          </div>
          <div className={styles['comment_container']}>
            <MapOfferCardCommentContainer />
          </div>
          {isShowClientComment && (
            <div>
              <ClientComment isSearcherOrSub={isSearcherOrSub} clientReactions={clientReactions} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
